/**
 * Build-time flags for the UI scale engine. Kept apart from uiScale.ts and
 * DeviceModeContext so jest (ts-jest CommonJS cannot parse `import.meta`) can mock it.
 */

/** `?device=phone|tablet|kiosk|desktop` is honoured only in dev or a UI preview build. */
export function isDeviceOverrideAllowed(): boolean {
  return Boolean(import.meta.env.DEV) || import.meta.env.VITE_UI_PREVIEW === 'true';
}
